module.exports = __webpack_public_path__ + "static/media/Tier_9.b1baf436.png";